import { render, staticRenderFns } from "./myOrderMgt.vue?vue&type=template&id=37d9d1a2&scoped=true&"
import script from "./myOrderMgt.vue?vue&type=script&lang=js&"
export * from "./myOrderMgt.vue?vue&type=script&lang=js&"
import style0 from "./myOrderMgt.vue?vue&type=style&index=0&id=37d9d1a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d9d1a2",
  null
  
)

export default component.exports